import angular from 'angular';

import ResourceMgmt from './resourcesManagement.component';
import './resourcesManagement.component.scss';

import { downgradedModule } from '../../../ng-app/main';

export default angular
  .module('petroCloud.admin.resources', [
    downgradedModule
  ])
  .component(ResourceMgmt.name, ResourceMgmt)
  .name;
